// Module
var code = " <span>{{ title }}</span> <ng-content></ng-content> ";
// Exports
module.exports = code;